import { HttpParams } from '@angular/common/http';
import { FiltroSgsia } from './filtro-sgsia';

export class ControleAcessoFiltroSgsia extends FiltroSgsia {
    idPessoaFiscal: number;
    nmFiscal: string;
    nrSolicitacao: string;
    nrDocumento: string;
    uf: string;
    situacao: string;
    ativo: boolean;
    cdPerfil: string;
    nrCnpj: string;

    getAsHTTPParams(): HttpParams {
        let params = super.getAsHTTPParams();
        if (this.idPessoaFiscal != null) {
            params = params.set('idPessoaFiscal', this.idPessoaFiscal.toString());
        }
        if (this.nmFiscal != null) {
            params = params.set('nmFiscal', this.nmFiscal);
        }
        if (this.nrSolicitacao != null) {
            params = params.set('nrSolicitacao', this.nrSolicitacao);
        }
        if (this.nrDocumento != null) {
            params = params.set('nrDocumento', this.nrDocumento);
        }
        if (this.uf != null) {
            params = params.set('uf', this.uf);
        }
        if (this.situacao != null) {
            params = params.set('situacao', this.situacao);
        }
        if (this.ativo != null) {
            params = params.set('ativo', this.ativo ? 'ATIVO' : 'INATIVO');
        }
        if (this.cdPerfil != null) {
            params = params.set('cdPerfil', this.cdPerfil);
        }
        if (this.nrCnpj != null) {
            params = params.set('nrCnpj', this.nrCnpj);
        }
        return params;
    }
}
